import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { AuthError } from 'aws-amplify/auth'
import { NavController } from '@ionic/angular/standalone'
import { SessionActionsService } from '@shared/services/session-actions.service'

export const authGuard: CanActivateFn = async () => {
  if (typeof window !== 'undefined' && (window as { __PW_BYPASS_AUTH_GUARD__?: boolean }).__PW_BYPASS_AUTH_GUARD__) {
    return true
  }

  const refreshTokenService = inject(SessionActionsService)
  const navController = inject(NavController)

  try {
    await refreshTokenService.refreshSession()
  } catch (error) {
    if (error instanceof AuthError) {
      switch (error.name) {
        case 'UserUnAuthenticatedException':
          navController.navigateBack('session/login')
      }
    }
    return false
  }
  return true
}
